export function isValidDOB(dob?: { day?: number; month?: number; year?: number }): boolean {
  const day = Number(dob?.day);
  const month = Number(dob?.month);
  const year = Number(dob?.year);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return false;
  }

  const date = new Date(year, month, day);

  return date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day;

}